export default __webpack_public_path__ + "static/media/pequod.8e5f9544.png";